import React from 'react';
import './EntryPrice.less';
import {convertPrice} from "helpers/format.helper";

export const EntryPrice = ({price}) => {
	return <div className="entry-price">{convertPrice(price)}</div>;
};
